export default __webpack_public_path__ + "abbb74c82b614144ad1980af57b3fc35.png";